var requireNonNull = require('util/require-non-null');

/**
 * Wrapper for a security store update script. Required to provide a unique type
 * to act as a serialisation key.
 * 
 * @class
 */
function SecurityCommandScript(script) {
    this.script = requireNonNull(script, "script");
}

SecurityCommandScript.prototype.toString = function() {
    return "SecurityCommandScript [" + this.script + "]";
};

module.exports = SecurityCommandScript;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/authentication/security-command-script.js
// module id = 199
// module chunks = 1